import React from "react";
import Navbar from "../../components/Navbar";
import Hero from "./Hero";
import "./Home.css";
import Footer from "../../components/Footer";
import SEO from "../../components/SEO";
import { getWebSiteSchema, getOrganizationSchema, getTravelAgencySchema } from "../../components/SEO/schemaTemplates";

function HomePage() {
  const homeSchema = {
    "@context": "https://schema.org",
    "@graph": [
      getWebSiteSchema(),
      getOrganizationSchema(),
      getTravelAgencySchema()
    ]
  };

  return (
    <div className="home">     
      <SEO 
        title="Soloway | Explore Sri Lanka - Hotels, Local Guides & Stays"
        description="Book verified Sri Lanka hotels, hire certified local tour guides, and explore the most famous places in Sri Lanka. Authentic island travel with Soloway.lk."
        keywords="sri lanka hotel, sri lanka guides, most famous places sri lanka, travel sri lanka, ella hotels, sigiriya guides, colombo accommodation, yala safari"
        canonicalPath="/"
        schemaJson={homeSchema}
      />
      <Navbar />
      <Hero/>
      {/* Features */}
      <section className="features">
        <div className="feature border">
          <h3>Traveler</h3>
          <p>
            Search, book, and manage tours, hotels, and visas while earning coins and sharing travel experiences.
          </p>
        </div>
        <div className="feature border">
          <h3>Guide</h3>
          <p>
            Create and manage tour listings, set availability, receive bookings, chat with travelers, and withdraw earnings.
          </p>
        </div>
        <div className="feature">
          <h3>Hotel Owner</h3>
          <p>
            List and manage rooms, control availability, handle bookings, respond to guest messages, and track earnings.
          </p>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default HomePage;